import React, { ReactElement } from "react";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import enumStrings, { RoutePaths } from "../../../enumStrings";
import ErrorBasePage from "./ErrorBasePage";

const Error404 = (): ReactElement => {
  const realRoutePaths = Object.values(RoutePaths);

  const actualRoutePath = window.location.pathname.toLowerCase();

  // A real dashboard page that is not in this user's routes: the user does
  // not have access to it (audit 3.1 item 12). It used to be a blank page.
  if (realRoutePaths.includes(actualRoutePath as RoutePaths)) {
    return (
      <ErrorBasePage
        eyebrow={enumStrings.pages.noPageAccess.eyebrow}
        subtitle={enumStrings.pages.noPageAccess.subtitle}
        description={enumStrings.pages.noPageAccess.description}
        emailSubject={enumStrings.pages.noPageAccess.emailSubject}
        icon={<LockOutlinedIcon />}
        tone="neutral"
      />
    );
  }

  return (
    <ErrorBasePage
      eyebrow={`Error ${enumStrings.pages.error404.title}`}
      subtitle={enumStrings.pages.error404.subtitle}
      description={enumStrings.pages.error404.description}
      emailSubject={enumStrings.pages.error404.emailSubject}
      icon={<SearchOffIcon />}
      tone="gold"
    />
  );
};

export default Error404;
